import path from "ramda/es/path";
import identity from "ramda/es/identity";
import split from "ramda/es/split";
import memoizeWithIdentity from "ramda-extension/es/memoizeWithIdentity";
import { createSelector } from 'reselect';
import { REDUCER_NAME } from '../../constants/temporaryStore';
/**
 * get temporary store for given form
 *
 * @documented
 * @category Selector
 * @example
 *
 * 	getTemporaryStore('formName')(state)
 *
 */ export const getTemporaryStore = memoizeWithIdentity((temporaryStore)=>createSelector(path(split('.', temporaryStore)), identity));
/**
 * get temporary form data for given form
 *
 * @documented
 * @category Selector
 * @example
 *
 * 	getTemporaryFormData('formName')(state)
 *
 */ export const getTemporaryFormData = memoizeWithIdentity((formName)=>createSelector(path([
        formName,
        REDUCER_NAME
    ]), identity));
